


















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ListViewItem from "./listviewitem";
import  EnumTypeList from "./EnumTypeList";

@Component({
  name: "ui-list-view-tabs"
})
export default class UiListViewTabsComponent extends Vue {
  @Prop({ default: () => {}, type: Array })
  Items!: Array<ListViewItem<any>>;

  @Prop({ default: false, type: Boolean })
  multiselect!: boolean;

  @Prop({ default: EnumTypeList[1], type: String })
  typeView: EnumTypeList;

  @Prop({ default: false, type: Boolean })
  selectAccess!: boolean;

  innerTypeView = this.typeView;

  onSelect(value: ListViewItem<any>) {
    if (!this.multiselect) {
      this.Items.forEach(
        item => (item.Selected = item.Value.Equal(value.Value))
      );
    }
    this.$emit("select", value);
  }

  onChangeTabs(title: String, index: number) {
    switch (index) {
      case 0:
        this.changeView(EnumTypeList.box);
        break;
      default:
        this.changeView(EnumTypeList.line);
        break;
    }
  }

  changeView(val: number) {
    this.innerTypeView = EnumTypeList[val];;
  }

  updated() {
    this.$children.forEach(item => item.$on("select", this.onSelect));
  }
  mounted() {
    this.$children.forEach(item => item.$on("select", this.onSelect));
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-components/~/list-view/src/ui-list-view-tabs.vue